import React, { useCallback, useEffect } from 'react';

import { Typography, Space } from '@sravni/react-design-system';
import { useAbTestingSdk, useBoolean, useIsMobile, useStyles } from '@sravni/react-utils';

import commonStyles from '../../../../styles/common.module.scss';
import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { RecentActionsBlock } from '../../../RecentActionsBlock';
import { useRecentActions } from '../../../RecentActionsBlock/hooks/useRecentActions';
import { SERVICE_MENU, ServiceMenu } from '../../../ServiceMenu/index_variantB';
import { productCardsData as productCardsDataVariantA } from '../../constants/productCardsData';
import { productCardsData as productCardsDataVariantB } from '../../constants/productCardsData_variantB';
import { ProductCard } from '../ProductCard/ProductCard';

import styles from './ProductCardsContainer.module.scss';

export const ProductCardsContainer = React.memo(() => {
  const abTestingSdk = useAbTestingSdk();
  const isBtest = abTestingSdk.checkExperimentVariant('45b0dac3-ad00-4e0a', '1');
  const productCardsData = isBtest ? productCardsDataVariantB : productCardsDataVariantA;
  const { recentActions, getRecentActions } = useRecentActions();
  const { orders, calculations } = recentActions;
  const [withBanner, setWithBanner] = useBoolean(false);
  const [visibleServiceMenu, setVisibleServiceMenu] = useBoolean(false);
  const isMobile = useIsMobile();
  const cx = useStyles(styles);
  const cxCommon = useStyles(commonStyles);

  const cardsContainerClassnames = cx('gridContainer', {
    withBanner: !isMobile && withBanner,
    isMobile,
  });

  useEffect(() => {
    if (!!orders?.length || !!calculations?.length) {
      setWithBanner.on();
    } else {
      setWithBanner.off();
    }
  }, [orders, calculations, setWithBanner]);

  const handleClick = useCallback(
    (path: string, eventCategory: string, eventLabel?: string) => {
      if (path === SERVICE_MENU) {
        setVisibleServiceMenu.on();
        pushEvent(
          makeMainGEvent({
            eventAction: 'Открытие попапа',
            eventCategory: 'Все услуги',
            eventLabel: undefined,
            eventValue: undefined,
          }),
        );

        return;
      }

      pushEvent(
        makeMainGEvent({
          eventAction: 'Переход из плиток',
          eventCategory,
          eventLabel,
          eventValue: undefined,
        }),
      );

      document.location.href = `${path}`;
    },
    [setVisibleServiceMenu],
  );

  const tailCardsKey = ['education', 'business', 'kasko', 'refinancing'];

  const bannerSlot = (
    <div className={cx('bannerSlot', { isMobile })}>
      <RecentActionsBlock recentActions={recentActions} isMobile={isMobile} onDelete={getRecentActions} />
    </div>
  );

  return (
    <>
      <div className={cxCommon('wrapper', 'whiteBackground')} suppressHydrationWarning>
        <div className={`${cxCommon('inner')} ${cx('titleWrapper')}`}>
          <Typography.Heading level={3} as={'h1'} className={cx('title')}>
            Помогаем сохранить деньги
          </Typography.Heading>
          {withBanner && isMobile && bannerSlot}
        </div>
      </div>

      <Space className={cx('barContainer')}>
        <div className={cx('bar')}>
          {withBanner && !isMobile && bannerSlot}
          <div className={cardsContainerClassnames}>
            {productCardsData.map((data) => (
              <div
                key={data.key}
                style={{ gridArea: data.key, ...data.customStyle }}
                className={cx('cardWrapper', {
                  withBanner: !isMobile && withBanner && tailCardsKey.includes(data.key),
                })}
              >
                <ProductCard productData={data} isMobile={isMobile} onClick={handleClick} />
              </div>
            ))}
          </div>
        </div>
      </Space>
      <ServiceMenu visible={visibleServiceMenu} isMobile={isMobile} onClose={setVisibleServiceMenu.off} />
    </>
  );
});
